import PageHero from "@/components/jf/PageHero";
import Shop from "@/components/jf/Shop";
import Reveal from "@/components/jf/Reveal";

const ASSURANCES = [
  ["Made to Order", "Crafted after you book — never mass produced."],
  ["Our Own Factory", "Cut, joined and polished under one Jaipur roof."],
  ["Pan-India Delivery", "Delivered and installed at your doorstep."],
];

export default function ShopPage({ onBook }) {
  return (
    <main>
      <PageHero
        kicker="The Collection"
        title={<>Furniture you can <em className="text-brass-soft font-light">book today.</em></>}
        accent="08"
      >
        <p className="mt-8 max-w-xl text-ivory/70 font-light leading-relaxed text-base md:text-lg">
          Signature pieces in solid sheesham and teak — each made to order by our own artisans
          after you place your booking.
        </p>
      </PageHero>
      <Shop onBook={onBook} />
      <section data-testid="shop-assurances" className="bg-oxblood-ink py-16">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid sm:grid-cols-3 gap-10">
          {ASSURANCES.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.07}>
              <div data-testid={`assurance-${i}`} className="text-center">
                <p className="font-display italic text-brass-soft text-2xl">{t}</p>
                <p className="mt-3 text-ivory/50 font-light text-sm leading-relaxed">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
